module.exports = __webpack_public_path__ + "img/D&D-Elemente_Ellipse_Kapitel4.78c9b394.svg";